import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useSidebarStore = create(
  persist(
    (set, get) => ({
      // 사이드바 상태 (true: 펼침, false: 접힘)
      isExpanded: true,
      
      // 사이드바 토글
      toggleSidebar: () => {
        const currentState = get().isExpanded;
        set({ isExpanded: !currentState });
        console.log('[SIDEBAR]', 'Sidebar toggled:', !currentState ? 'expanded' : 'collapsed');
      },
      
      // 사이드바 펼치기
      expandSidebar: () => {
        set({ isExpanded: true });
        console.log('[SIDEBAR]', 'Sidebar expanded');
      },
      
      // 사이드바 접기
      collapseSidebar: () => {
        set({ isExpanded: false });
        console.log('[SIDEBAR]', 'Sidebar collapsed');
      }
    }),
    {
      name: 'sidebar-storage',
      partialize: (state) => ({
        isExpanded: state.isExpanded
      })
    }
  )
);

export default useSidebarStore;